export default state => ({
  ...state,
  hasGlobalError: false,
  errorMessage: null,
  reloadOnGlobalError: false,
});
